import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response, Pagination } from '@ui/src';
import { changeLogsApi } from './service';
import { ChangeLog } from '../types';

export interface ChangeLogsState {
  changeLogs?: ChangeLog[];
  pagination?: Pagination;
}

const initialState: ChangeLogsState = {};

export const changeLogsSlice = createSlice({
  name: 'changeLogs',
  initialState,
  reducers: {
    clearChangeLogs: (state) => {
      state.changeLogs = undefined;
      state.pagination = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      changeLogsApi.endpoints.getChangeLogs.matchFulfilled,
      (
        state,
        action: PayloadAction<Response<ChangeLog>> & {
          meta: { arg: { originalArgs: string } };
        },
      ) => {
        if (!action.meta.arg.originalArgs.includes('cursor')) {
          state.changeLogs = action.payload.data?.edges?.map(
            (item) => item.node,
          );
        } else {
          const nextChangeLogs = ([] as ChangeLog[]).concat(
            state.changeLogs as ChangeLog[],
          );

          action.payload.data.edges?.forEach((item) => {
            nextChangeLogs.push(item.node);
          });

          state.changeLogs = nextChangeLogs;
        }

        state.pagination = action.payload.data?.pageInfo;
      },
    );
  },
});

export const { clearChangeLogs } = changeLogsSlice.actions;

export default changeLogsSlice.reducer;
